import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../Environment/environment';
@Component({
  selector: 'app-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrl: './image-popup.component.css'
})
export class ImagePopupComponent {
  /**
   *
   */
  constructor(public dialog: MatDialog,) {
    this.AssetbasePath = environment.assetsPath;
  }
  AssetbasePath:any;
  @Output() close = new EventEmitter<void>();

  // closePopup() {
  //   this.close.emit();
  // }
  closePopup(){
    this.dialog.closeAll()
    }
}
